import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-343cd2fe")

_pushScopeId("data-v-343cd2fe")
const _hoisted_1 = { class: "select-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Typ kódu", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NewCustomer = _resolveComponent("NewCustomer")
  const _component_Employee = _resolveComponent("Employee")
  const _component_MobileUserAnyPacketBdsToBranchRedirected = _resolveComponent("MobileUserAnyPacketBdsToBranchRedirected")
  const _component_DestinationTypes = _resolveComponent("DestinationTypes")
  const _directive_detect_click = _resolveDirective("detect-click")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createVNode("div", {
        class: "group",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleInput()))
      }, [
        _createVNode("div", {
          class: ["wrap", { clearEdge : _ctx.visible }]
        }, [
          _createVNode("div", {
            class: ["input", { edge : _ctx.visible }]
          }, [
            _createVNode("span", null, _toDisplayString(_ctx.getApplierName(_ctx.promocodeType)), 1)
          ], 2)
        ], 2),
        _createVNode("div", {
          class: ["arrow", { dropped : _ctx.visible }]
        }, null, 2),
        _createVNode("div", {
          class: { hidden : !_ctx.visible, visible: _ctx.visible }
        }, [
          _createVNode("ul", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.types, (value, index) => {
              return (_openBlock(), _createBlock("li", {
                class: { lastLi : (_ctx.types.length-1) === index , current : value.type === _ctx.promocodeType },
                key: value.type,
                onClick: ($event: any) => {_ctx.select(
              value.type,
            );}
              }, _toDisplayString(value.name), 11, ["onClick"]))
            }), 128))
          ])
        ], 2)
      ], 512), [
        [_directive_detect_click, _ctx.toggleInputOutside]
      ])
    ]),
    (_ctx.promocodeType === 'new-customer')
      ? (_openBlock(), _createBlock(_component_NewCustomer, {
          key: 0,
          onApplyNewCustomerConfiguration: _ctx.applyNewCustomerConfiguration,
          "mobile-user-count-of-packets": _ctx.mobileUserCountOfPackets
        }, null, 8, ["onApplyNewCustomerConfiguration", "mobile-user-count-of-packets"]))
      : _createCommentVNode("", true),
    (_ctx.promocodeType === 'employee')
      ? (_openBlock(), _createBlock(_component_Employee, {
          key: 1,
          onApplyEmployeeConfiguration: _ctx.applyEmployeeConfiguration,
          "consumer-groups": _ctx.consumerGroups,
          "promocode-consumer-group": _ctx.promocodeConsumerGroup
        }, null, 8, ["onApplyEmployeeConfiguration", "consumer-groups", "promocode-consumer-group"]))
      : _createCommentVNode("", true),
    (_ctx.promocodeType === 'mobile-user-any-packets-bds-to-branch-redirected')
      ? (_openBlock(), _createBlock(_component_MobileUserAnyPacketBdsToBranchRedirected, {
          key: 2,
          onApplyMobileUserAnyPacketBdsToBranchRedirectedConfiguration: _ctx.applyMobileUserAnyPacketBdsToBranchRedirectedConfiguration,
          "mobile-user-any-packet-bds-to-branch-latest-packet-date": _ctx.mobileUserAnyPacketBdsToBranchLatestPacketDate
        }, null, 8, ["onApplyMobileUserAnyPacketBdsToBranchRedirectedConfiguration", "mobile-user-any-packet-bds-to-branch-latest-packet-date"]))
      : _createCommentVNode("", true),
    (_ctx.promocodeType === 'simple-destination-type')
      ? (_openBlock(), _createBlock(_component_DestinationTypes, {
          key: 3,
          onApplyDestinationTypeConfiguration: _ctx.applyDestinationTypeConfiguration,
          "destination-types": _ctx.destinationTypes
        }, null, 8, ["onApplyDestinationTypeConfiguration", "destination-types"]))
      : _createCommentVNode("", true)
  ], 64))
})